(() => {
  const screen = document.querySelector('[data-loading-screen]');
  let api = window.AmbitionLoading;
  if (!api) {
    api = window.AmbitionLoading = { ready: Promise.resolve({ reason: 'no-bootstrap' }), phase: 'ready', progress: 0, skip() {} };
    document.dispatchEvent(new CustomEvent('ambition:reveal', { detail: { reason: 'no-bootstrap' } }));
    document.dispatchEvent(new CustomEvent('ambition:ready', { detail: { reason: 'no-bootstrap' } }));
    return;
  }
  if (!screen || api.phase === 'ready') {
    api.complete?.('no-screen-or-ready');
    return;
  }
  const motion = matchMedia('(prefers-reduced-motion:reduce)');
  const progressBar = screen.querySelector('[data-loading-progress]');
  const percent = screen.querySelector('[data-loading-percent]');
  const identity = screen.querySelector('[data-loading-identity]');
  const animations = new Set();
  let settled = 0;
  screen.hidden = false;

  function cleanup() {
    animations.forEach(animation => animation.cancel());
    animations.clear();
    document.removeEventListener('keydown', onKey);
    screen.removeEventListener('pointerdown', onPointer);
    document.removeEventListener('visibilitychange', onVisibility);
    motion.removeEventListener('change', onMotion);
  }
  function exit(reason = 'assets', immediate = false) {
    if (api.phase === 'ready') return api.ready;
    if (immediate || motion.matches || document.hidden) {
      cleanup();
      api.complete(reason);
      return api.ready;
    }
    if (api.phase === 'revealing') return api.ready;
    api.reveal(reason);
    const mark = identity.animate({ opacity: [1, 0], transform: ['translateY(0)', 'translateY(-18px)'] }, { duration: 380, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
    const curtain = screen.animate({ clipPath: ['inset(0 0 0 0)', 'inset(0 0 100% 0)'] }, { duration: 620, easing: 'cubic-bezier(.65,0,.2,1)', fill: 'forwards' });
    animations.add(mark); animations.add(curtain);
    curtain.finished.then(() => { api.complete(reason); cleanup(); }, () => { api.complete(reason); cleanup(); });
    return api.ready;
  }
  api.skip = (reason = 'interaction') => exit(reason, true);
  function onKey(event) { if (['Escape','Tab','PageDown','ArrowDown',' '].includes(event.key)) api.skip('keyboard'); }
  function onPointer() { api.skip('pointer'); }
  function onVisibility() { if (document.hidden) api.skip('hidden'); }
  function onMotion() { if (motion.matches) api.skip('reduced-motion'); }
  document.addEventListener('keydown', onKey);
  screen.addEventListener('pointerdown', onPointer);
  document.addEventListener('visibilitychange', onVisibility);
  motion.addEventListener('change', onMotion);
  document.addEventListener('ambition:ready', cleanup, { once: true });

  function imageReady(image) {
    if (!image) return Promise.resolve();
    const decode = () => image.naturalWidth && image.decode ? image.decode().catch(() => {}) : Promise.resolve();
    if (image.complete) return decode();
    return new Promise(resolve => {
      image.addEventListener('load', () => decode().then(resolve), { once: true });
      image.addEventListener('error', resolve, { once: true });
    });
  }
  const resources = [
    document.fonts?.ready || Promise.resolve(),
    imageReady(document.querySelector('.hero-art img')),
    imageReady(document.querySelector('.hero-heading img'))
  ];
  function recordProgress() {
    settled += 1;
    if (api.phase !== 'loading') return;
    api.progress = settled / resources.length;
    screen.style.setProperty('--loading-progress', api.progress);
    const value = Math.round(api.progress * 100);
    progressBar.setAttribute('aria-valuenow', String(value));
    percent.textContent = value + '%';
  }
  Promise.allSettled(resources.map(resource => Promise.resolve(resource).then(recordProgress, recordProgress))).then(() => exit('assets'));
})();
